import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import styled from "styled-components";

const RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP = getSpacing("1x");

export const InfoWrapper = styled(Column).attrs({ justify: "space-between" })`
  flex: 1;
  min-width: 0;
  padding: ${getSpacing(0, 0, 0, "2x")};
  width: 100%;
`;

export const ResultsDropdownSectionsWrapper = styled.div`
  padding-top: ${RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP};
`;
